// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"99":"e021d584","117":"ad000a35","326":"e448f917","390":"36467fae","437":"bfd74eb6","758":"a932b626","970":"12e6df47"}[chunkId] + ".js";
};